export default "__VITE_ASSET__DxPdk8eY__"